import React, { FC,useEffect,useState } from "react";
import CommonLayout from "./CommonLayout";
import Textarea from "shared/Textarea/Textarea";
import Checkbox from "shared/Checkbox/Checkbox";

import { AuthorType, ListingDataType } from "data/types";
import { useLocation } from 'react-router-dom';
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { Link, useNavigate } from 'react-router-dom';

export interface PageAddListing7Props { }

const PageAddListing7: FC<PageAddListing7Props> = () => {

  const location = useLocation();
  const propertyInfo = location.state;
  const agent = propertyInfo.agent as AuthorType;
  const property = propertyInfo.property as ListingDataType;
  const [appliances, setAppliances] = useState('');
  const [interior, setInterior] = useState('');
  const [exterior, setExterior] = useState('');
  const [otherAmenities, setOtherAmenities] = useState('');
  const navigate = useNavigate();

  type CheckedItems = Record<string, boolean>;
  const [checkedItems, setCheckedItems] = useState<CheckedItems>({});

  useEffect(() => {
    // console.log(propertyInfo);
    //console.log(property);
    //  console.log(agent);
    checkValues();
  }, []);
  
  const checkValues = () =>{

    setAppliances(property.factsFeatures?.appliances?.join(', ') || '');
    setInterior(property.factsFeatures?.interior?.join(', ') || '');
    setExterior(property.factsFeatures?.accesability?.join(', ') || '');
    // setOtherAmenities(property.bathrooms || 0);


  }

const handleApplianceChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
  setAppliances(event.target.value);
};

const handleInteriorChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
  setInterior(event.target.value);
};

const handleExteriorChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
  setExterior(event.target.value);
};

const handleOtherAmenitiesChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
  setOtherAmenities(event.target.value);
};


const handleCheckItems = (event: React.ChangeEvent<HTMLInputElement>) => {
  const { name, checked } = event.target;
  const updatedItems = { ...checkedItems };
  if (checked) {
    updatedItems[name] = true;
  } else {
    delete updatedItems[name];
  }
  setCheckedItems(updatedItems);
};

const toNextStep = () => {
  if (property.factsFeatures) {
     property.factsFeatures.appliances = appliances.split(',').map(item => item.trim()); 
     property.factsFeatures.interior = interior.split(',').map(item => item.trim()); 
     property.factsFeatures.accesability = exterior.split(',').map(item => item.trim()); 
  }
  property.author =  agent;

  if (appliances.length === 0 || interior.length === 0 || exterior.length === 0){
    console.error('All fields must be filled out');
    return;
  }

// const propertyInfo = {
//   property,
//   agent,
// };
navigate('/add-listing-10', { state: property });
// console.log(propertyInfo);

}


const toPrevtStep = () => {
  const propertyInfo = {
    property,
    agent,
  };

navigate('/add-listing-4', { state: propertyInfo });
}


  return (
    <div
    className={`nc-PageAddListing2 px-4 max-w-3xl mx-auto pb-24 pt-14 sm:py-24 lg:pb-32`}
    data-nc-id="PageAddListing2"
  >
    <div className="space-y-11">
      <div>
        <span className="text-4xl font-semibold">4</span>{" "}
        <span className="text-lg text-neutral-500 dark:text-neutral-400">
          / 5
        </span>
      </div>
        <div>
          <h2 className="text-2xl font-semibold">Additional Comments</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
          </span>
        </div>

        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="listingSection__wrap ">
        <div className="space-y-8">
          {/* ********old design******* */}
          {/* <div>
            <span className="text-lg font-semibold">Cover image</span>
            <div className="mt-5 ">
              <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-neutral-300 dark:border-neutral-6000 border-dashed rounded-md">
                <div className="space-y-1 text-center">
                  <svg
                    className="mx-auto h-12 w-12 text-neutral-400"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 48 48"
                    aria-hidden="true"
                  >
                    <path
                      d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <div className="flex text-sm text-neutral-6000 dark:text-neutral-300">
                    <label
                      htmlFor="file-upload"
                      className="relative cursor-pointer  rounded-md font-medium text-primary-6000 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
                    >
                      <span>Upload a file</span>
                      <input
                        id="file-upload"
                        name="file-upload"
                        type="file"
                        className="sr-only"
                      />
                    </label>
                    <p className="pl-1">or drag and drop</p>
                  </div>
                  <p className="text-xs text-neutral-500 dark:text-neutral-400">
                    PNG, JPG, GIF up to 10MB
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <span className="text-lg font-semibold">Interior/Exterior Images</span>
            <div className="mt-5 ">
              <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-neutral-300 dark:border-neutral-6000 border-dashed rounded-md">
                <div className="space-y-1 text-center">
                  <svg
                    className="mx-auto h-12 w-12 text-neutral-400"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 48 48"
                    aria-hidden="true"
                  >
                    <path
                      d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <div className="flex text-sm text-neutral-6000 dark:text-neutral-300">
                    <label
                      htmlFor="file-upload-2"
                      className="relative cursor-pointer  rounded-md font-medium text-primary-6000 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
                    >
                      <span>Upload a file</span>
                      <input
                        id="file-upload-2"
                        name="file-upload-2"
                        type="file"
                        className="sr-only"
                      />
                    </label>
                    <p className="pl-1">or drag and drop</p>
                  </div>
                  <p className="text-xs text-neutral-500 dark:text-neutral-400">
                    PNG, JPG, GIF up to 10MB
                  </p>
                </div>
              </div>
            </div>
          </div> */}
          {/* ********End old design******* */}

          <div>
            <span className="text-xl ">
              Appliances
            </span>
          </div>

          <Textarea placeholder="Type here." rows={8} 
           value={appliances || ''} 
          onChange={handleApplianceChange}
          />

          <div>
            <span className="text-xl ">
              Interior features
            </span>
          </div>

          <Textarea placeholder="Type here." rows={8} 
           value={interior || ''} 
          onChange={handleInteriorChange}
          />

          <div>
            <span className="text-xl ">
              Exterior features
            </span>
          </div>

          <Textarea placeholder="Type here." rows={8} 
           value={exterior || ''} 
          onChange={handleExteriorChange}
          />
          <div>
            <span className="text-xl ">
              Nearby amenities
            </span>
          </div>
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <div className={`flex text-sm sm:text-base`}>
                <input
                  id="Bicking"
                  name="Bicking"
                  type="checkbox"
                  className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  onChange={handleCheckItems}
                />
                <label
                  className="ml-3.5 flex flex-col flex-1 justify-center"
                >
                  <span className=" text-neutral-900 dark:text-neutral-100">
                  Bicking
                  </span>
                </label>
              </div>
              <div className={`flex text-sm sm:text-base`}>
                <input
                  id="Beach"
                  name="Beach"
                  type="checkbox"
                  className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  onChange={handleCheckItems}
                />
                <label
                  className="ml-3.5 flex flex-col flex-1 justify-center"
                >
                  <span className=" text-neutral-900 dark:text-neutral-100">
                  Beach
                  </span>
                </label>
              </div>
              <div className={`flex text-sm sm:text-base`}>
                <input
                  id="Golf"
                  name="Golf"
                  type="checkbox"
                  className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  onChange={handleCheckItems}
                />
                <label
                  className="ml-3.5 flex flex-col flex-1 justify-center"
                >
                  <span className=" text-neutral-900 dark:text-neutral-100">
                  Golf
                  </span>
                </label>
              </div>
              <div className={`flex text-sm sm:text-base`}>
                <input
                  id="Shopping"
                  name="Shopping"
                  type="checkbox"
                  className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  onChange={handleCheckItems}
                />
                <label
                  className="ml-3.5 flex flex-col flex-1 justify-center"
                >
                  <span className=" text-neutral-900 dark:text-neutral-100">
                  Shopping
                  </span>
                </label>
              </div>
              <div className={`flex text-sm sm:text-base`}>
                <input
                  id="Pool"
                  name="Pool"
                  type="checkbox"
                  className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  onChange={handleCheckItems}
                />
                <label
                  className="ml-3.5 flex flex-col flex-1 justify-center"
                >
                  <span className=" text-neutral-900 dark:text-neutral-100">
                  Pool
                  </span>
                </label>
              </div>
              <div className={`flex text-sm sm:text-base`}>
                <input
                  id="Park"
                  name="Park"
                  type="checkbox"
                  className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  onChange={handleCheckItems}
                />
                <label
                  className="ml-3.5 flex flex-col flex-1 justify-center"
                >
                  <span className=" text-neutral-900 dark:text-neutral-100">
                  Park
                  </span>
                </label>
              </div>
              <div className={`flex text-sm sm:text-base`}>
                <input
                  id="Movies"
                  name="Movies"
                  type="checkbox"
                  className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  onChange={handleCheckItems}
                />
                <label
                  className="ml-3.5 flex flex-col flex-1 justify-center"
                >
                  <span className=" text-neutral-900 dark:text-neutral-100">
                  Movies
                  </span>
                </label>
              </div>
              <div className={`flex text-sm sm:text-base`}>
                <input
                  id="Supermarkets"
                  name="Supermarkets"
                  type="checkbox"
                  className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  onChange={handleCheckItems}
                />
                <label
                  className="ml-3.5 flex flex-col flex-1 justify-center"
                >
                  <span className=" text-neutral-900 dark:text-neutral-100">
                  Supermarkets
                  </span>
                </label>
              </div>
              <div className={`flex text-sm sm:text-base`}>
                <input
                  id="Restaurants"
                  name="Restaurants"
                  type="checkbox"
                  className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  onChange={handleCheckItems}
                />
                <label
                  className="ml-3.5 flex flex-col flex-1 justify-center"
                >
                  <span className=" text-neutral-900 dark:text-neutral-100">
                  Restaurants
                  </span>
                </label>
              </div>
              <div className={`flex text-sm sm:text-base`}>
                <input
                  id="Mall"
                  name="Mall"
                  type="checkbox"
                  className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  onChange={handleCheckItems}
                />
                <label
                  className="ml-3.5 flex flex-col flex-1 justify-center"
                >
                  <span className=" text-neutral-900 dark:text-neutral-100">
                  Mall
                  </span>
                </label>
              </div>
         

{/* 
            <Checkbox label="Bicking" name="Bicking" />
            <Checkbox label="Beach" name="Beach" />
            <Checkbox label="Golf" name="Golf" />
            <Checkbox label="Shopping" name="Shopping" />
            <Checkbox label="Pool" name="Pool" />
            <Checkbox label="Park" name="Park" />
            <Checkbox label="Movies" name="Movies" />
            <Checkbox label="Supermarkets" name="Supermarkets" />
            <Checkbox label="Restaurants" name="Restaurants" />
            <Checkbox label="Mall" name="Mall" /> */}

          </div>

          <div>
            <span className="text-xl ">
              Other
            </span>
          </div>

          <Textarea placeholder="Type here." rows={8} 
          onChange={handleOtherAmenitiesChange}
          />
          </div>
        </div>
        <div className="flex justify-end space-x-5">
          <ButtonSecondary onClick={toPrevtStep}>Go back</ButtonSecondary>
          <ButtonPrimary onClick={toNextStep}> {"Continue"} </ButtonPrimary>
        </div>
        </div>
      </div>
  );
};

export default PageAddListing7;
